import { H4 } from '@rezdy/components/Heading';
import Icon from '@rezdy/components/Icon';
import TextStyle from '@rezdy/components/TextStyle';
import React from 'react';

export function LoadingDots() {
    return (
        <TextStyle align="center">
            <H4>
                <Icon name="loader-dots" size="large" />
            </H4>
        </TextStyle>
    );
}

export default LoadingDots;
